import { render, staticRenderFns } from "./DisputeEvent.vue?vue&type=template&id=5e49f913&scoped=true&"
import script from "./DisputeEvent.vue?vue&type=script&lang=js&"
export * from "./DisputeEvent.vue?vue&type=script&lang=js&"
import style0 from "./DisputeEvent.vue?vue&type=style&index=0&id=5e49f913&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e49f913",
  null
  
)

export default component.exports